import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
//import DataTableExtensions from 'react-data-table-component-extensions';
import "react-data-table-component-extensions/dist/index.css";
//service
import { formatNumberWithCommasAndDecimal } from "../../helper";
import style from "./ilifepoint.module.scss";
import { Filter } from ".";
import moment from "moment";
import PointsHistoryModal from "./PointsHistoryModal";
import eye from "../../../assets/icons/open-eye.png";
import OrderService from "../../../service/orderHistory/orderHistory";
import CurrencyLatestSeperator from "../../helper/currencyLatestSeperator";

function HistorysTable({
  ContentData,
  paginationchange,
  exportData,
  loader,
  selectedTab,
}) {
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();
  const Currency = useSelector((state) => state.curr);
  const [modalShow, setModalShow] = useState(false);
  const [selectedPointsHistory, setSelectedPointsHistory] = useState(null);
  const columns = [
    {
      name: "Transaction Date",
      selector: (row) => {
        const adjustedTimestamp = moment
          .utc(row.transaction_date)
          .subtract(8, "hours");
        const formattedDate = adjustedTimestamp
          .tz("Asia/Manila")
          .format("MM/DD/YYYY h:mm:ss A");

        return <span>{formattedDate}</span>;
      },
      width: "30%",
    },
    {
      name: "Ref No",
      selector: (row) => row.ref_no,
    },
    {
      name: "Details",
      selector: (row) => row.details,
    },
    {
      name: "Total Value",
      selector: (row) => row.total_value,
      cell: (row) => (
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "40%" }}
        >
          {CurrencyLatestSeperator(
            row.total_value * Currency.value,
            Currency.precision
          )}
        </div>
      ),
    },
    {
      name: "Total Points",
      selector: (row) => row.total_points,
      cell: (row) => (
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "40%" }}
        >
          {formatNumberWithCommasAndDecimal(
            row.total_points * Currency.value,
            Currency.precision
          )}
        </div>
      ),
    },
    {
      name: "Action",
      selector: (row) =>
        row.is_repurchase && (
          <u
            onClick={() => handleActionClick(row)}
            style={{ cursor: "pointer" }}
          >
            <img src={eye} style={{ height: "20px" }} alt="View" />
          </u>
        ),
    },
  ];

  const handleClose = () => {
    setModalShow(false);
  };
  const handleActionClick = (row) => {
    console.log("rowww inside row click", row.order_id);
    let service = new OrderService();
    service.getOrderdetailsForLifeStyle(row.order_id).then((res) => {
      // if(res.status){
      if (res?.error) {
        console.log("error", res?.error?.description);
      } else {
        console.log("res", res.codeResult);
        setSelectedPointsHistory(res);
        setModalShow(true);
      }
    });
  };
  const [state, setState] = useState({ data: [] });
  const [date, SetDate] = useState({
    start: moment().startOf("month").format("YYYY-MM-DD"),
    end: moment().format("YYYY-MM-DD"),
    selectedValues: [],
  });

  const { data } = state;

  useEffect(() => {
    if (ContentData.data) {
      let NewData = ContentData.data.map((resData) => {
        return {
          ref_no: resData.ref_no,
          details: resData.details,
          total_value: resData.total_value,
          total_points: resData.total_points,
          is_repurchase: resData.is_repurchase,
          transaction_date: resData.transaction_date,
          order_id: resData.order_id,
        };
      });
      setState((prev) => ({
        ...prev,
        data: NewData,
      }));
    }
  }, [ContentData]);
  const handlePerRowsChange = (perPage, inPage) => {
    let keys = [];
    date.selectedValues.map((key, idx) => {
      keys.push(key.value);
    });
    paginationchange(inPage, perPage, date.start, date.end, "", "", keys);
  };
  const handlePageChange = (inPage) => {
    let keys = [];
    date.selectedValues.map((key, idx) => {
      keys.push(key.value);
    });
    paginationchange(
      inPage,
      ContentData.perPage,
      date.start,
      date.end,
      "",
      "",
      keys
    );
  };
  const handleOnSort = ({ selector }, sortDirection) => {
    let keys = [];
    date.selectedValues.map((key, idx) => {
      keys.push(key.value);
    });
    paginationchange(
      ContentData.inPage,
      ContentData.perPage,
      date?.start,
      date?.end,

      sortDirection,
      selector,
      keys
    );
  };
  const filterHandlet = (start, end, type = "") => {
    SetDate((prev) => ({
      ...prev,
      start: start,
      end: end,
      selectedValues: type,
    }));
    let keys = [];
    type.map((key, idx) => {
      keys.push(key.value);
    });
    loader.StatementTable.search = true;
    paginationchange(
      ContentData.inPage,
      ContentData.perPage,
      start,
      end,
      "",
      "",
      keys
    );
  };

  //reset handler
  const resetData = () => {
    SetDate((prev) => ({
      ...prev,
      start: moment().startOf("month").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
    }));
    loader.StatementTable.reset = true;
    paginationchange(
      ContentData.inPage,
      ContentData.perPage,
      moment().startOf("month").format("MMMM D, YYYY"),
      moment().format("MMMM D, YYYY"),
      "",
      "",
      ""
    );
  };

  return (
    <>
      {/* {ContentData.category.length !== 0 && ( */}
      <PointsHistoryModal
        show={modalShow}
        handleClose={handleClose}
        data={selectedPointsHistory}
        onHide={() => setModalShow(false)}
      />
      <Filter
        filterHandler={filterHandlet}
        // type={ConvertData(ContentData.category)}
        resetHandler={resetData}
        isSingle={false}
        exports={true}
        exportData={exportData}
        ContentData={ContentData}
        loader={loader}
        selectedTab={selectedTab}
        isTypeRequired={false}
      />
      <DataTable
        columns={columns}
        data={data}
        highlightOnHover
        progressPending={ContentData.pending}
        progressComponent={<div>Loading</div>}
        persistTableHead
        noHeader
        pagination
        paginationServer
        responsive
        paginationTotalRows={ContentData.totalRows}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        noDataComponent={t("Common.noDataRecordsToDisplay")}
        //onSort={handleOnSort}
      />
    </>
  );
}

export default HistorysTable;
